// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA4mxra35qdOihrNDCGfIjsfcRZoeZ3B_w",
  authDomain: "ecommerce-25faa.firebaseapp.com",
  projectId: "ecommerce-25faa",
  storageBucket: "ecommerce-25faa.appspot.com",
  messagingSenderId: "30924417348",
  appId: "1:30924417348:web:461cf28bd69a392c720f11"
};

// Initialize Firebase
initializeApp(firebaseConfig);